module.exports = __webpack_public_path__ + "static/media/logo.109cd726.jpg";